import React, { useEffect, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../assets/img/Daimler_Logo_Text.png";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "react-bootstrap";
import preloadimg from "../../assets/img/preloader1.gif";
import uiConfig from "../../config/uiConfig";

import { FaBars } from "react-icons/fa";
import EditNoteIcon from "@mui/icons-material/EditNote";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import ChatRoomNew from "../comments/Comments";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Notifications from "../notifications/Notifications";
import Bookmark from "../bookmark/Bookmark";
import { useNavHeader } from "../../hooks/useNavHeader";
import { getToken } from "../auth/authConfig";

const NavHeader = ({ title, guid, reportId, pageName, groupId, onclickmenu }) => {
  const {
    fetchUserGroupList,
    fetchUserDetails,
    updateDefaultUserGroup,
    updateDefaultRlType,
  } = useNavHeader();

  const headerLogoStyle = {
    width: uiConfig.headerLogoWidth ?? 271,
    height: uiConfig.headerLogoHeight ?? "auto",
    padding: uiConfig.headerLogoPadding ?? 0,
    margin: uiConfig.headerLogoMargin ?? 0,
  };

  const [Switching, setSwitching] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [CheckGroupId, setCheckGroupId] = useState([]);
  const [openDialog, setopenDialog] = useState(false);
  const [personaId, setpersonaId] = useState();
  const [personaName, setpersonaName] = useState("");
  const { instance } = useMsal();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const menubar = () => {
    var sideBar = document.getElementById("mySidenav").style.width;
    if (sideBar === "") {
      document.getElementById("mySidenav").style.width = "300px";
      document.getElementById("main").style.marginLeft = "305px";
      $(".item_menuText").show();
      $(".sideNavMenu_grid").css("justify-content", "start");
      $(".sideNavMenu").css("overflow-y", "auto");
    } else if (sideBar === "80px") {
      document.getElementById("mySidenav").style.width = "300px";
      document.getElementById("main").style.marginLeft = "305px";
      $(".item_menuText").show();
      $(".sideNavMenu_grid").css("justify-content", "start");
      $(".sideNavMenu").css("overflow-y", "auto");
    } else {
      document.getElementById("mySidenav").style.width = "80px";
      document.getElementById("main").style.marginLeft = "85px";
      $(".item_menuText").hide();
      $(".sideNavMenu_grid").css("justify-content", "center");
      $(".sideNavMenu").css("overflow-y", "hidden");
    }
  };

  useEffect(() => {
    if (onclickmenu === true) {
      document.getElementById("main").style.marginLeft = "305px";
    }
  }, [onclickmenu]);

  const notifications = () => {
    const x = document.getElementById("NotificationsIdValues");
    if (x.style.display === "") {
      $("#NotificationsIdValues").toggle(0);
      $("#main").css("marginRight", "400px");
    } else if (x.style.display === "none") {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "400px");
    } else {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "6px");
    }
  };

  const email = localStorage.getItem("myemail");
  const userNameLocal = localStorage.getItem("userName");
  const navigate = useNavigate();

  const switchPersona = () => {
    setSwitching(true);
    setopenDialog(false);

    if (CheckGroupId.includes(104)) updateRLtype();

    updateDefaultUserGroup(email, personaId)
      .then(() => {
        setSwitching(false);
        setpersonaId();
        setpersonaName("");
        navigate("/");
        window.location.reload();
      })
      .catch(() => {
        setSwitching(false);
      });
  };

  const [selectedItem, setSelectedItem] = useState("");
  const [RLLoading, SetRLLoading] = useState(true);

  const updateRLtype = () => {
    updateDefaultRlType(selectedItem).catch((error) => {
      console.log(error);
    });
  };
  useEffect(() => {
    let isMounted = true;
    const fetchToken = async () => {
      try {
        await getToken();
      } catch (error) {
        if (isMounted) console.error("Failed to acquire token", error);
      }
    };
    fetchToken();
    return () => {
      isMounted = false;
    };
  }, [instance]);

  useEffect(() => {
    fetchUserGroupList()
      .then((json) => {
        const userGroupIds = json.map((item) => item.userGroupId);
        setCheckGroupId(userGroupIds);
      })
      .catch(() => {});
  }, [fetchUserGroupList]);

  // console.log(CheckGroupId)

  useEffect(() => {
    fetchUserDetails()
      .then((json) => {
        const defaultData = json;
        const defaultRLData = defaultData?.defaultRlType;
        const defaultRLDataLsitId = defaultData?.defaultUserGroup;

        setSelectedItem(defaultRLData);
        SetRLLoading(false);
        localStorage.setItem("userGroup", defaultRLDataLsitId);
        localStorage.setItem("RLTYPE", defaultRLData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [fetchUserDetails]);

  
  return (
    <>
      <Navbar
        style={{
          paddingLeft: "2rem",
          paddingRight: "2rem",
          justifyContent: "space-between",
          border: "1px solid #D9D9D9",
        }}
        className="nav_bar navFlexbox"
        expand="lg"
        variant="light"
        fixed="top"
      >
        <div className="nav-items logo-placement">
          <FaBars
            onClick={menubar}
            style={{ color: uiConfig.iconColor || "#A70E13" }}
            fontSize={24}
            cursor="pointer"
          />

          <Navbar.Brand
            style={{ background: "transparent !important" }}
            href="/"
          >
            <img
              src={uiConfig.headerLogo || Logo}
              className="d-inline-block align-top"
              alt="Bharat Benz"
              style={headerLogoStyle}
            />
          </Navbar.Brand>
        </div>
        {uiConfig.headerTitle ? (
          <div className="tool-name">
            <h4>{uiConfig.headerTitle}</h4>
          </div>
        ) : null}

        <div
          style={{ background: "transparent !important" }}
          className="nav-items"
        >
          <Bookmark />

          {reportId && (
            <>
              <EditNoteIcon
                style={{
                  fontSize: "35px",
                  cursor: "pointer",
                  background: "transparent !important",
                  color: 'var(--app-icon-color, #bb1ccc)',
                  marginRight: "20px",
                }}
                id="notificationIDclick"
                value={{ color: "white" }}
                onClick={notifications}
              />
            </>
          )}

          <Notifications />

          <Box
            sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
          >
            <Tooltip title="Account settings">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "24px",
                    position: "relative",
                    width: "auto",
                    height: "36px",
                    borderRadius: "26.5px",
                    border: "1px solid #000",
                    paddingLeft: "16px",
                  }}
                >
                  <div
                    style={{
                      color: "#2c2c2c",
                      fontSize: "16px",
                    }}
                    className="item_bar profileDetails"
                  >
                    <div> {userNameLocal || "User"}</div>
                  </div>
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      backgroundColor: "var(--app-icon-color)",
                      color: "white",
                      fontWeight: "600",
                    }}
                  >
                    {userNameLocal ? userNameLocal.charAt(0) : "U"}
                  </Avatar>
               
                </div>
              </IconButton>
            </Tooltip>
          </Box>

        
        </div>
      </Navbar>

      <div id="NotificationsIdValues" className="notificationsCss">
        <ChatRoomNew
          title={title}
          guid={guid}
          reportId={reportId}
          pageName={pageName}
          groupId={groupId}
        />
      </div>

      {/* <div id="NotesValues" className="notificationsCss">
        <Notifications />
      </div> */}

      <Dialog
        open={openDialog}
        onClose={() => setopenDialog(!openDialog)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          style={{ background: "#A70E13", color: "#fff", fontWeight: "500" }}
          id="alert-dialog-title"
        >
          {"Switching Persona!!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: "16px", color: "#8A9295" }}
          >
            <>Do you wish to switch to {personaName}?</>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="submit_btn"
            style={{ width: "auto" }}
            onClick={switchPersona}
            autoFocus
            disabled={personaId !== 104 ? false : RLLoading}
          >
            Yes
          </Button>

          <Button
            className="cancel_btn"
            style={{ width: "auto" }}
            onClick={() => setopenDialog(false)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {Switching && (
        <div
          style={{ fontSize: "18px", fontWeight: "600" }}
          className="switchingClass"
        >
          <div
            style={{
              position: "fixed",
              background: "rgba(0,0,0,0.8)",
              width: "100%",
              height: "100%",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              zIndex: "99999",
              justifyItems: "center",
              alignContent: "center",
            }}
          >
            <img width={200} src={preloadimg} alt="Loading" />
            <span>Switching to {personaName}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default NavHeader;
